import service from '../api/message.service';

//constants
const dataMessage = {
    messages: [],
    createMessage: [],
    deleteMessage: [],
    updateMessage: [],
    messageError: ''
}
//Message
const LIST_MESSAGES = 'LIST_MESSAGES'
const CREATE_MESSAGES = 'CREATE_MESSAGES'
const DELETE_MESSAGES = 'DELETE_MESSAGES'
const UPDATE_MESSAGES = 'UPDATE_MESSAGES'
const ERROR_MESSAGES = 'ERROR_MESSAGES'

//reducer
export default function MessageReducer(state = dataMessage, action) {
    switch (action.type) {
        case LIST_MESSAGES:
            return { ...state, messages: action.payload };
        case CREATE_MESSAGES:
            return { ...state, createMessage: action.payload };
        case DELETE_MESSAGES:
            return { ...state, deleteMessage: action.payload };
        case UPDATE_MESSAGES:
            return { ...state, updateMessage: action.payload };
        case ERROR_MESSAGES:
            return { ...state, messageError: action.payload };
        default:
            return { ...state };
    }
}

export const findAll = (username) => async (dispatch) => {
    const response = await service.getMessage("0", username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_MESSAGES,
            payload: response
        });
        dispatch({
            type: LIST_MESSAGES,
            payload: []
        });
    } else {
        dispatch({
            type: ERROR_MESSAGES,
            payload: ''
        });
        dispatch({
            type: LIST_MESSAGES,
            payload: response
        });
    }

    return response;
}
export const findByType = (type,username) => async (dispatch) => {
    const response = await service.findByType(type, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_MESSAGES,
            payload: response
        });
        dispatch({
            type: LIST_MESSAGES,
            payload: []
        });
    } else {
        dispatch({
            type: ERROR_MESSAGES,
            payload: ''
        });
        dispatch({
            type: LIST_MESSAGES,
            payload: response
        });
    }

    return response;
}
export const createMessage = (message, username) => async (dispatch) => {
    const response = await service.getCreateMessage(message, username).then((r) => { return r });
    dispatch({
        type: CREATE_MESSAGES,
        payload: response
    });
    return response;
}

export const deleteMessage = (lsData, username) => async (dispatch) => {
    const response = await service.getDeleteMessage(lsData, username).then((r) => { return r });
    dispatch({
        type: DELETE_MESSAGES,
        payload: response
    });
    return response;
}

export const updateMessage = (message, username) => async (dispatch) => {
    const response = await service.getUpdateMessage(message, username).then((r) => { return r });
    dispatch({
        type: UPDATE_MESSAGES,
        payload: response
    });
    return response;
}